import { render, staticRenderFns } from "./governance.vue?vue&type=template&id=fb950a8a&"
import script from "./governance.vue?vue&type=script&lang=js&"
export * from "./governance.vue?vue&type=script&lang=js&"
import style0 from "./governance.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports